import { encrypt } from '@/utils/crypto'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface StoreState {
  token: string | null
  tokenKey: string
  setToken: (token: string) => void
  clearToken: () => void
}

const TOKEN_KEY = 'masterpiece_token'

const useTokenStore = create<StoreState>()(
  persist(
    (set) => ({
      token: null,
      tokenKey: TOKEN_KEY,
      setToken: (token: string) => set({ token: encrypt(token) }),
      clearToken: () => set({ token: null }),
    }),
    {
      // Project Management End of the Smart Bracelet token 转换 为 Base64 编码
      name: TOKEN_KEY, // 存储的键名
      storage: createJSONStorage(() => localStorage), // 使用localStorage存储
    },
  ),
)

export default useTokenStore
